import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import TimestampNumber from './TimestampNumber';
import { getTimestampNumbers } from './Timestamp.helpers';
import { overflowTextOffset } from '@polestar/component-warehouse-react/helpers/style';
const Timestamp = forwardRef(({ value, background = true, ...props }, ref) => (React.createElement(Container, { ...props, ref: ref, background: background },
    React.createElement(ItemContainer, { background: background }, typeof value === 'string'
        ? value
        : getTimestampNumbers(value).map((timeValue, index) => timeValue === ':' ? ':' : React.createElement(TimestampNumber, { key: index, value: timeValue }))))));
Timestamp.displayName = 'Timestamp';
export default Timestamp;
const Container = styled.div(({ theme, background }) => css(css `
      position: relative;
      display: flex;
      flex-direction: row;
      user-select: none;
      color: ${theme.timestamp.color};
      justify-content: center;
      align-items: center;
      height: ${createCustomSpacing(20 / 16)};

      ${overflowTextOffset};
    `, background &&
    css `
        color: ${theme.timestamp.background.color};
        background-color: ${theme.timestamp.background.backgroundColor};
        padding: ${createCustomSpacing(1 / 16)} ${Spacings.xxSmall};
      `));
Container.displayName = `Container`;
const ItemContainer = styled.span(({ background }) => css(css `
      display: flex;
    `, background &&
    css `
        margin-top: ${createCustomSpacing(2 / 16)};
      `));
